// WhatsApp Message Generator for FlowBerry Orders

import { businessInfo } from '../data/mockData';

const WHATSAPP_BASE = businessInfo.whatsappLink;

/**
 * Generate WhatsApp order message
 */
export const generateOrderMessage = ({
  variety,
  stemLength,
  quantity,
  premiumWrap,
  deliveryMethod,
  address,
  customerName,
  customerPhone,
  preferredDateTime,
  notes,
  estimatedTotal,
}) => {
  const wrapText = premiumWrap ? 'Premium Wrap (+$20)' : 'No wrap (ribbon bow included)';
  const deliveryText = deliveryMethod === 'delivery' 
    ? `Delivery\n• Delivery note: Los Angeles (from $10)${address ? ` — Address: ${address}` : ''}` 
    : 'Pickup (Glendale)';

  let message = `Hi! I'd like to order a custom rose bouquet from FlowBerry (Glendale / LA).

• Rose variety: ${variety}
• Stem length: ${stemLength} cm
• Quantity: ${quantity} stems
• Premium wrap: ${wrapText}
• Delivery method: ${deliveryText}
• Estimated total: $${estimatedTotal}`;

  if (customerName) {
    message += `\n\nName: ${customerName}`;
  }
  if (customerPhone) {
    message += `\nPhone: ${customerPhone}`;
  }
  if (preferredDateTime) {
    message += `\nPreferred delivery/pickup date & time: ${preferredDateTime}`;
  }
  if (notes) {
    message += `\nNotes: ${notes}`;
  }

  return message;
};

/**
 * Generate WhatsApp URL with encoded message
 */
export const generateWhatsAppURL = (message) => {
  const encodedMessage = encodeURIComponent(message);
  return `${WHATSAPP_BASE}?text=${encodedMessage}`;
};

/**
 * Generate default inquiry message
 */
export const getDefaultInquiryURL = () => {
  const message = "Hi! I'd like to place an order. Please help me choose a bouquet.";
  return generateWhatsAppURL(message);
};

/**
 * Open WhatsApp with order message
 */
export const openWhatsAppOrder = (orderDetails) => {
  const message = generateOrderMessage(orderDetails);
  const url = generateWhatsAppURL(message);
  window.open(url, '_blank');
};

export default {
  generateOrderMessage,
  generateWhatsAppURL,
  getDefaultInquiryURL,
  openWhatsAppOrder,
};
